import React from 'react';

import SignupForm from '../../SignupForm';
import SmartPayOnboardingErrorContent from './SmartPayOnboardingErrorContent';
import { useSignupDialogOnboardingContext } from '../../../contexts/SignupDialogOnboardingContextProvider';

const Error = ({ closeDialog }) => {
    const { onboardError, setOnboardError } = useSignupDialogOnboardingContext();

    return (
        <SignupForm onBack={() => setOnboardError(null)} onNext={closeDialog}>
            <SmartPayOnboardingErrorContent errorCode={onboardError!} />
        </SignupForm>
    );
};

export default Error;
